import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/erp`;
const inst = axios.create({ baseURL: API });

inst.interceptors.request.use((c) => {
  const t = localStorage.getItem('erp_token');
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const erpLogin = (d) => inst.post('/auth/login', d);
export const erpMe = () => inst.get('/auth/me');
export const erpDashboard = () => inst.get('/dashboard');
export const erpList = (path, params) => inst.get(`/${path}`, { params });
export const erpCreate = (path, d) => inst.post(`/${path}`, d);
export const erpUpdate = (path, id, d) => inst.put(`/${path}/${id}`, d);
export const erpSearch = (q) => inst.get('/search', { params: { q } });
export const erpGet = (path, params) => inst.get(`/${path}`, { params });
export const erpPost = (path, d) => inst.post(`/${path}`, d || {});
export const erpOpenPdf = async (path) => {
  const r = await inst.get(`/${path}`, { responseType: 'blob' });
  window.open(URL.createObjectURL(r.data), '_blank', 'noopener');
};
export const erpStockTxn = (d) => inst.post('/stock/transaction', d);
export const erpStockLedger = (sku_id) => inst.get('/stock/ledger', { params: { sku_id } });

export default inst;
